import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  getProfileAction,
  saveUserProfileAction,
  updateUserProfileAction,
} from "../../../store/Profile/ProfileAction";
import { useDispatch, useSelector } from "react-redux";
import Toastiy from "../../universal/Toastiy";
import { setShowNavigationAlertAction } from "../../../store/GlobalLoader/GlobalLoaderAction";
import { updateUserProfileInfoAction } from "../../../store/Users/UsersAction";
import { parseProfileDobForPicker, serializeProfileDobForApi } from "../../../utils/profileDate";
import {
  getDefaultRouteForAccess,
  pickPreferredCmsProfile,
  resolveProfilePortalAccess,
} from "../../../utils/portalAccess";

export const ProfileHooks = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { userInfo } = useSelector((state) => state.user);
  const [value, setValue] = useState();
  const [editProfile, setEditProfile] = useState(true);
  const [imageUrl, setImageUrl] = useState();
  const [profileValues, setProfileValues] = useState({
    _id: "",
    profilePicUrl: "",
    firstName: "",
    lastName: "",
    gender: "male",
    dob: null,
    aboutMe: "",
    mobile: "",
    email: "",
    active: 1,
    language_prefference: "",
    country: "",
  });

  useEffect(() => {
    return () => setShowNavigationAlert(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const setShowNavigationAlert = (value) => {
    dispatch(setShowNavigationAlertAction(value));
  };

  const applyProfileResponse = (res, options = {}) => {
    if (res?.type !== 1 || !Array.isArray(res?.data) || res.data.length === 0) {
      return null;
    }

    const selectedProfile = pickPreferredCmsProfile(res.data) || res.data[0];
    if (!selectedProfile) return null;

    dispatch(updateUserProfileInfoAction(selectedProfile));
    setProfileValues((prevState) => ({
      ...prevState,
      firstName: selectedProfile?.firstName || "",
      lastName: selectedProfile?.lastName || "",
      gender: selectedProfile?.gender || prevState.gender,
      dob: parseProfileDobForPicker(selectedProfile?.dob),
      aboutMe: selectedProfile?.aboutMe || "",
      profilePicUrl: selectedProfile?.profilePicUrl || "",
      email: selectedProfile?.email || "",
      mobile: selectedProfile?.mobile || "",
      country: selectedProfile?.country || "",
      _id: selectedProfile?._id || "",
      active: selectedProfile?.active ?? prevState.active,
      language_prefference:
        selectedProfile?.language_prefference || prevState.language_prefference || "",
    }));

    if (options.navigateAfterUpdate) {
      const access = resolveProfilePortalAccess(selectedProfile);
      if (access !== "none") {
        navigate(getDefaultRouteForAccess(access), { replace: true });
      }
    }

    return selectedProfile;
  };

  const refreshProfileAfterMutation = (fallbackProfileValues) => {
    dispatch(
      getProfileAction({
        apiPayloadRequest: {},
        callback: (profileRes) => {
          const refreshedProfile = applyProfileResponse(profileRes, {
            navigateAfterUpdate: true,
          });

          if (!refreshedProfile && fallbackProfileValues) {
            dispatch(
              updateUserProfileInfoAction({
                ...userInfo,
                ...fallbackProfileValues,
              })
            );
          }
        },
      })
    );
  };

  const handleChange = (event) => {
    const { name, value } = event.target;

    setProfileValues((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    if (name === "profilePicUrl") {
      dispatch(
        updateUserProfileInfoAction({
          ...userInfo,
          profilePicUrl: value,
        })
      );
    }
    setShowNavigationAlert(true);
  };

  const onChangeSearchBar = (e) => {
    setValue(e.target.value);
  };

  useEffect(() => {
    getProfileData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getProfileData = () => {
    dispatch(
      getProfileAction({
        apiPayloadRequest: {},
        callback: getProfileSuccess,
      })
    );
  };

  const getProfileSuccess = (res) => {
    applyProfileResponse(res);
  };

  const handleUpdateProfile = () => {
    const apiPayloadRequest = {
      ...profileValues,
      dob: serializeProfileDobForApi(profileValues?.dob),
    };

    if (profileValues?._id !== "") {
      dispatch(
        updateUserProfileAction({
          apiPayloadRequest,
          callback: (res) => {
            if (res?.type === 1) {
              Toastiy("Profile Saved Successfully!", res?.type);
              refreshProfileAfterMutation(apiPayloadRequest);
              setEditProfile((prevState) => !prevState);
              setShowNavigationAlert(false);
            } else {
              Toastiy("Something Went Wrong!", res?.type);
            }
          },
        })
      );
    } else {
      dispatch(
        saveUserProfileAction({
          apiPayloadRequest,
          callback: (res) => {
            if (res?.type === 1) {
              Toastiy("Profile Updated Successfully!", res?.type);
              refreshProfileAfterMutation(apiPayloadRequest);
              setShowNavigationAlert(false);
            } else {
              Toastiy("Something Went Wrong!", res?.type);
            }
          },
        })
      );
    }
  };

  return {
    value,
    editProfile,
    setEditProfile,
    profileValues,
    handleChange,
    onChangeSearchBar,
    imageUrl,
    setImageUrl,
    handleUpdateProfile,
    setProfileValues,
  };
};
